module.exports = __webpack_public_path__ + "./images/199868cca8820768627a88679c53c393.webp";